import { render, staticRenderFns } from "./taskRecord.vue?vue&type=template&id=040d0ebd&scoped=true"
import script from "./taskRecord.vue?vue&type=script&lang=js"
export * from "./taskRecord.vue?vue&type=script&lang=js"
import style0 from "./taskRecord.vue?vue&type=style&index=0&id=040d0ebd&prod&lang=scss&scoped=true"
import style1 from "./taskRecord.vue?vue&type=style&index=1&id=040d0ebd&prod&scoped=true&lang=css"
import style2 from "./taskRecord.vue?vue&type=style&index=2&id=040d0ebd&prod&lang=scss&scoped=true"
import style3 from "./taskRecord.vue?vue&type=style&index=3&id=040d0ebd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040d0ebd",
  null
  
)

export default component.exports